import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue, update } from 'firebase/database';
import './AssignUser.css';

const AssignUser = () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState('');
    const [selectedRole, setSelectedRole] = useState('');
    const [selectedClass, setSelectedClass] = useState('');
    const [message, setMessage] = useState('');

    const db = getDatabase();

    useEffect(() => {
        const usersRef = ref(db, 'users');
        onValue(usersRef, (snapshot) => {
            const data = snapshot.val();
            const userList = [];
            for (let id in data) {
                userList.push({ id, ...data[id] });
            }
            setUsers(userList);
        });
    }, [db]);

    const handleAssign = () => {
        if (!selectedUser) {
            setMessage('Please select a user.');
            return;
        }

        const updates = {};
        if (selectedRole) {
            updates[`/users/${selectedUser}/role`] = selectedRole;
        }

        const selectedUserData = users.find(user => user.id === selectedUser);

        if (selectedUserData && selectedUserData.role === 'student') {
            updates[`/users/${selectedUser}/class`] = selectedClass;
        } else if (selectedRole === 'student') {
            updates[`/users/${selectedUser}/class`] = selectedClass;
        }


        update(ref(db), updates)
            .then(() => {
                setMessage('User updated successfully!');
            })
            .catch((error) => {
                setMessage(`Error: ${error.message}`);
            });
    };

    return (
        <div className="assign-user-container">
            <h2>Assign Role and Class to User</h2>
            {message && <p>{message}</p>}
            <div className="form-group">
                <label>Select User</label>
                <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)}>
                    <option value="">-- Select User --</option>
                    {users.map(user => (
                        <option key={user.id} value={user.id}>{user.fullName} ({user.email})</option>
                    ))}
                </select>
            </div>
            <div className="form-group">
                <label>Select Role</label>
                <select value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
                    <option value="">-- Select Role --</option>
                    <option value="student">Student</option>
                    <option value="teacher">Teacher</option>
                    <option value="parent">Parent</option>
                    <option value="admin">Admin</option>
                    <option value="principal">Principal</option>
                    <option value="cashier">Cashier</option>
                    <option value="form-master">Form Master</option>
                </select>
            </div>
            {(users.find(user => user.id === selectedUser)?.role === 'student' || selectedRole === 'student') && (
                <div className="form-group">
                    <label>Select Class</label>
                    <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}>
                        <option value="">-- Select Class --</option>
                        <option value="KG 1">KG 1</option>
                        <option value="KG 2">KG 2</option>
                        <option value="Nursery 1">Nursery 1</option>
                        <option value="Nursery 2">Nursery 2</option>
                        <option value="Primary 1">Primary 1</option>
                        <option value="Primary 2">Primary 2</option>
                        <option value="Primary 3">Primary 3</option>
                        <option value="Primary 4">Primary 4</option>
                        <option value="Primary 5">Primary 5</option>
                        <option value="Primary 6">Primary 6</option>
                        <option value="JSS 1">JSS 1</option>
                        <option value="JSS 2">JSS 2</option>
                        <option value="JSS 3">JSS 3</option>
                        <option value="SSS1">SSS1</option>
                        <option value="SSS2 ARTS">SSS2 ARTS</option>
                        <option value="SSS2 SCIENCE">SSS2 SCIENCE</option>
                        <option value="SSS2 COMMERCIAL">SSS2 COMMERCIAL</option>
                        <option value="SSS3 ARTS">SSS3 ARTS</option>
                        <option value="SSS3 SCIENCE">SSS3 SCIENCE</option>
                        <option value="SSS3 COMMERCIAL">SSS3 COMMERCIAL</option>
                    </select>
                </div>
            )}
            <button onClick={handleAssign}>Assign</button>
        </div>
    );
};

export default AssignUser;
